import React from 'react';
import Seo from '@/components/Seo';
import { Icon, Reveal, Section } from '@/components/ui';
import { blogContent } from '@/content/blog';

function formatDate(iso: string): string {
    return new Date(iso).toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });
}

/**
 * Blog/News list page template (§11 of
 * `docs/TEMPLATE_IMPROVEMENT_RECOMMENDATIONS.md`). Content lives in
 * `src/content/blog.ts` — swap the sample posts for real ones, or back this
 * file with a headless CMS / MDX (see `docs/CMS_ADAPTER.md`).
 */
const Blog: React.FC = () => {
    return (
        <>
            <Seo title={blogContent.title} path="/blog" breadcrumbs={[]} />
            <Section id="blog" className="page-hero" contained>
                <h1 className="page-hero-title">{blogContent.title}</h1>
                <p className="page-hero-intro">{blogContent.intro}</p>
            </Section>

            <Section id="blog-posts" className="blog-list" contained>
                <div className="blog-grid">
                    {blogContent.posts.map((post, index) => (
                        <Reveal
                            as="article"
                            className="blog-card card"
                            key={post.slug}
                            delay={index * 100}
                        >
                            <p className="blog-card-meta">
                                <span>
                                    <Icon name="calendar" />{' '}
                                    <time dateTime={post.date}>{formatDate(post.date)}</time>
                                </span>
                                <span>
                                    <Icon name="user" /> {post.author}
                                </span>
                            </p>
                            <h2 className="blog-card-title">{post.title}</h2>
                            <p className="blog-card-excerpt">{post.excerpt}</p>
                            <a className="blog-card-link" href={`/blog/${post.slug}`}>
                                Read more <Icon name="arrow-right" />
                            </a>
                        </Reveal>
                    ))}
                </div>
            </Section>
        </>
    );
};

export default Blog;
